import { useEffect } from "react";
import { useLocation } from "wouter";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Wraps a route. If user is not authenticated, redirects to /login.
 * Shows a quiet loading state while the auth check is in flight.
 */
export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const [, setLocation] = useLocation();

  useEffect(() => {
    if (user === false) {
      setLocation("/login");
    }
  }, [user, setLocation]);

  if (user === null) {
    return (
      <div className="min-h-screen bg-spa-cream flex items-center justify-center">
        <p className="text-spa-gray text-sm">Checking your session…</p>
      </div>
    );
  }
  if (user === false) return null;
  return children;
}
